import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import SeoHead from "../components/SeoHead";
import tokenomicsShellStyle from "../styles/tokenomicsShellStyle";

const TermsOfService = () => {
  return (
    <div className="tokenomics-shell" style={tokenomicsShellStyle}>
      <SeoHead
        title="Terms of Service | Atheriam"
        description="Read the Terms of Service for using Atheriam's website, blockchain tools, gaming products, whitepaper materials, and $ATH ecosystem services."
        path="/terms"
      />
      <Header />
      <main className="legal-page">
        <section className="legal-page__hero">
          <p className="legal-page__eyebrow">Legal</p>
          <h1 className="legal-page__title">
            Terms of <span>Service</span>
          </h1>
          <p className="legal-page__updated">Last updated: September 16, 2026</p>
        </section>

        <article className="legal-page__doc">
          <p>
            These Terms of Service (&quot;Terms&quot;) govern your access to and
            use of atheriam.com and related Atheriam services, including our
            website, whitepaper, tokenomics and ICO pages, blockchain tools,
            upcoming gaming experiences, and any software or interfaces we make
            available (collectively, the &quot;Services&quot;).
          </p>
          <p>
            By accessing or using the Services, you agree to these Terms. If you
            do not agree, do not use the Services.
          </p>

          <h2>1. About Atheriam</h2>
          <p>
            Atheriam is developing an Agentic AI-powered Layer 1 blockchain
            optimized for Web3 gaming. Features, timelines, token utilities,
            staking, ICO details, and gameplay offerings may change as the
            ecosystem evolves. Materials on the website are for informational
            purposes and do not guarantee future product availability.
          </p>

          <h2>2. Eligibility</h2>
          <ul>
            <li>You must be at least 18 years old (or the age of majority where you live)</li>
            <li>You must have legal capacity to enter into these Terms</li>
            <li>
              You must not use the Services if doing so would violate applicable
              laws, sanctions, or regulations in your jurisdiction
            </li>
          </ul>

          <h2>3. Accounts, wallets, and access</h2>
          <p>
            Some Services may require connecting a crypto wallet or interacting
            with smart contracts. You are solely responsible for:
          </p>
          <ul>
            <li>Securing your wallet, private keys, seed phrases, and devices</li>
            <li>All activity that occurs through your wallet or account</li>
            <li>Ensuring transactions you approve are intentional and correct</li>
          </ul>
          <p>
            Atheriam never asks for your private key or seed phrase. We are not
            responsible for losses caused by phishing, malware, compromised
            devices, or user error.
          </p>

          <h2>4. Acceptable use</h2>
          <p>You agree not to:</p>
          <ul>
            <li>Use the Services for illegal, fraudulent, or abusive activity</li>
            <li>Interfere with network security, smart contracts, or other users</li>
            <li>Exploit bugs, manipulate game outcomes, or attack infrastructure</li>
            <li>Scrape, reverse engineer, or disrupt Services except as allowed by law</li>
            <li>Misrepresent affiliation with Atheriam or impersonate others</li>
            <li>
              Use bots, scripts, or automated systems in ways that harm fairness,
              performance, or other participants
            </li>
          </ul>

          <h2>5. Blockchain, gaming, and digital assets</h2>
          <p>
            Interactions with Atheriam may involve public blockchains, gas fees,
            $ATH tokens, NFTs, in-game items, rewards, staking, or other digital
            assets. You understand and accept that:
          </p>
          <ul>
            <li>Blockchain transactions are generally irreversible once confirmed</li>
            <li>Network congestion, forks, or third-party failures may affect results</li>
            <li>Asset values can be volatile and may go to zero</li>
            <li>
              Game outcomes, rewards, and token utilities may depend on smart
              contracts, oracles, AI agents, and evolving product rules
            </li>
          </ul>

          <h2>6. No financial, investment, or legal advice</h2>
          <p>
            Nothing on the Services constitutes investment, financial, legal,
            tax, or trading advice. Tokenomics materials, whitepaper content, ICO
            announcements, and roadmap statements are informational only and may
            contain forward-looking statements that are uncertain.
          </p>
          <p>
            $ATH and related digital assets may be restricted or unavailable in
            some jurisdictions. You are responsible for determining whether you
            can legally participate.
          </p>

          <h2>7. ICO, staking, and promotions</h2>
          <p>
            Any token sale, staking program, airdrop, or promotional campaign
            will be governed by its own official terms when published. Until then,
            references to ICO, staking, or rewards are descriptive and not an
            offer to sell securities or financial products.
          </p>

          <h2>8. Intellectual property</h2>
          <p>
            Atheriam names, logos, branding, website design, text, graphics,
            software, and related content are owned by Atheriam or its licensors.
            You may not copy, modify, distribute, or commercially exploit our
            content without prior written permission, except for limited personal,
            non-commercial use of publicly available materials.
          </p>

          <h2>9. Third-party services</h2>
          <p>
            The Services may link to wallets, explorers, social platforms,
            marketplaces, or other third-party tools. We do not control and are
            not responsible for third-party content, policies, or security
            practices. Your use of those services is at your own risk.
          </p>

          <h2>10. Disclaimers</h2>
          <p>
            THE SERVICES ARE PROVIDED &quot;AS IS&quot; AND &quot;AS
            AVAILABLE.&quot; TO THE MAXIMUM EXTENT PERMITTED BY LAW, ATHERIAM
            DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING MERCHANTABILITY,
            FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. WE DO NOT
            WARRANT THAT THE SERVICES WILL BE UNINTERRUPTED, ERROR-FREE, OR
            SECURE.
          </p>

          <h2>11. Limitation of liability</h2>
          <p>
            TO THE MAXIMUM EXTENT PERMITTED BY LAW, ATHERIAM AND ITS TEAM MEMBERS,
            AFFILIATES, AND SERVICE PROVIDERS WILL NOT BE LIABLE FOR INDIRECT,
            INCIDENTAL, SPECIAL, CONSEQUENTIAL, EXEMPLARY, OR PUNITIVE DAMAGES, OR
            FOR LOSS OF PROFITS, DATA, DIGITAL ASSETS, GOODWILL, OR BUSINESS
            OPPORTUNITIES, ARISING OUT OF OR RELATED TO YOUR USE OF THE SERVICES.
          </p>
          <p>
            Without limiting the above, Atheriam is not liable for losses from
            wallet compromise, smart-contract bugs, network failures, market
            volatility, user mistakes, or unauthorized third-party actions.
          </p>

          <h2>12. Indemnification</h2>
          <p>
            You agree to defend, indemnify, and hold harmless Atheriam and its
            affiliates from claims, damages, losses, and expenses (including
            reasonable legal fees) arising from your use of the Services, your
            violation of these Terms, or your violation of any law or third-party
            rights.
          </p>

          <h2>13. Suspension and termination</h2>
          <p>
            We may suspend or terminate access to the Services at any time if we
            believe you violated these Terms, pose a security risk, or if required
            by law. You may stop using the Services at any time.
          </p>

          <h2>14. Changes to the Services or Terms</h2>
          <p>
            We may update the Services and these Terms from time to time. The
            &quot;Last updated&quot; date shows the latest revision. Continued
            use after changes become effective constitutes acceptance of the
            revised Terms.
          </p>

          <h2>15. Governing law</h2>
          <p>
            These Terms are governed by the laws applicable to Atheriam&apos;s
            operating entity, without regard to conflict-of-law principles.
            Courts in the applicable jurisdiction will have exclusive authority
            over disputes, except where mandatory consumer protections require
            otherwise.
          </p>

          <h2>16. Contact</h2>
          <p>
            Questions about these Terms can be sent through official Atheriam
            channels on{" "}
            <a
              href="https://x.com/AtheriamEco"
              target="_blank"
              rel="noreferrer"
            >
              X
            </a>{" "}
            or{" "}
            <a
              href="https://www.instagram.com/atheriamecosystem"
              target="_blank"
              rel="noreferrer"
            >
              Instagram
            </a>
            , or via support options published on atheriam.com.
          </p>

          <div className="legal-page__links">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/">Back to Home</Link>
          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
};

export default TermsOfService;
